import teams from '@/services/firestore/team'; // eslint-disable-next-line

export default function useTeam(db, id) {
  // Lookup widget record
  return teams.findRecord(db, id);
}